import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ActionHelper } from '../helper/action.helper';
import { AppFrameComponent } from '../app/page-modules/app-frame/app-frame.component';


// Define an interface for the component
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

type RouteChangeCallback = { (): void };

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {

  private static subscriptions = new Set<RouteChangeCallback>();

  static subscribeToRouteChange(callback: RouteChangeCallback) {
    this.subscriptions.add(callback);
  }

  private static notifyCallbacksAboutRouteChange() {
    for (const callback of this.subscriptions) {
      callback();
    }

    this.subscriptions.clear();
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise((resolve) => {
      if (ActionHelper.hasUnsavedChanges()) {
        AppFrameComponent.warnAboutUnsavedChanges((value) => {
          if (value) {
            CanDeactivateGuard.notifyCallbacksAboutRouteChange();
          }
          resolve(value);
        });
      } else {
        CanDeactivateGuard.notifyCallbacksAboutRouteChange();
        resolve(true);
      }
    })
  }
}
